import React from 'react';
import { Modal } from '../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';
import { Shimmer } from '../CommonComponents/OPL/Shimmer/Shimmer';
import { Box } from '../CommonComponents/OPL/Box/Box';

export const ManageExcessCashModalLoading = () => {
  return (
    <Modal isOpen size="large">
      <ModalHeader>
        <Shimmer width={150} height={32} />
      </ModalHeader>

      <ModalBody css="min-height: 40vh">
        <Box display="flex" flexDirection="column" css="gap: 16px">
          <Box>
            <Shimmer height={16} width={150} />
            <Shimmer height={37} mt={4} />
          </Box>
        </Box>
      </ModalBody>
    </Modal>
  );
};
